<div class="acceptancePage" fxLayout="column">
    <div class="head">
        <div class="imgbox">
            <img src="/assets/images/Arcon.jpg" alt="" class="headImg">
        </div>
        <span> REQUEST ID: <b>ARCUO8531169</b></span>
        <div fxLayout="row wrap" class="chipset">


            <ng-container [ngSwitch]="'one_way'">
                <ng-container *ngSwitchCase="'one_way'">
                    <mat-chip class="secondary-chip sleek-chip">One-way</mat-chip>
                    <mat-chip class="secondary-chip sleek-chip" *ngIf="true">Use</mat-chip>
                    <!-- <mat-chip class="secondary-chip sleek-chip"
                    *ngIf="requestService.selectedRequest?.transaction_type=='supply'">Supply</mat-chip> -->
                </ng-container>
                <ng-container *ngSwitchCase="'buy_sell'">
                    <mat-chip class="secondary-chip sleek-chip">Trade</mat-chip>
                    <!-- <mat-chip class="secondary-chip sleek-chip"
                    *ngIf="requestService.selectedRequest?.transaction_type=='use'">Buy</mat-chip> -->
                    <mat-chip class="secondary-chip sleek-chip" *ngIf="true">Sell</mat-chip>
                </ng-container>
                <mat-chip class="secondary-chip sleek-chip" *ngSwitchCase="'lease'">Lease</mat-chip>
            </ng-container>
            <!-- <mat-chip class="sleek-chip" style="color:white" [style.background-color]="'green'">Accepted</mat-chip> -->
            <!-- <mat-chip class="secondary-chip sleek-chip">Pending to Quote from 3 days</mat-chip> -->
        </div>
    </div>
    <ng-container *ngIf="!quoteAccepted">
        <div class="actionBtn">
            <button mat-raised-button class="addBtn clickIt" (click)="acceptQuote(true)">Accept Quote</button>
        </div>
        <logzy-content-loader [set3]="loader" *ngIf="loader"></logzy-content-loader>
        <div class="content form-group" id="card1" fxLayout="row wrap" fxFlex="{{basic}}" [class.d-none]="loader">

            <div fxFlex="100" class="inputs " fxLayout="row wrap" [ngClass]="expand? 'basicInfo-expand':'basicInfo' ">

                <!-- [list]="requestService.selectedRequest?.pols" -->
                <logzy-view-data-field [showPurpose]="true" name="Katupalli, IN" label="POL(s)"
                    [displayField]="'name_display'" fxFlex="11em" fxLayout="column"
                    class="align-items-center"></logzy-view-data-field>

                <!-- [list]="requestService.selectedRequest?.pods" -->
                <logzy-view-data-field [showPurpose]="true" name="Bremerhaven, DE" label="POD(s)"
                    [displayField]="'name_display'" fxFlex="11em" fxLayout="column"
                    class="align-items-center"></logzy-view-data-field>

                <!-- [list]="requestService.selectedRequest?.requirement" -->
                <logzy-view-data-field [showPurpose]="true" name="50*20 GP (Brand New)" label="Equipment"
                    [displayField]="'quantity'" [displayField1]="'container_size_type'" [displayField2]="'display'"
                    [displayField3]="'condition'" [displayField4]="'value'" [space1]="'*'" [space2]="'('" [space3]="')'"
                    fxFlex="11em" fxLayout="column" class="align-items-center"></logzy-view-data-field>

                <!-- [name]="requestService.selectedRequest"  -->
                <logzy-view-data-field [showPurpose]="true" name="Mr. Srinath Menon" label="Posted By"
                    [displayField]="'created_by'" [displayField1]="'first_name'" [displayField2]="'last_name'"
                    fxFlex="11em" fxLayout="column" class="align-items-center"></logzy-view-data-field>

                <!-- [date]="requestService.selectedRequest?.created_at"  -->
                <logzy-view-data-field [showPurpose]="true" name="23 Mar 2023, 02:41 PM" label="Posted On" fxFlex="11em"
                    fxLayout="column" class="align-items-center"></logzy-view-data-field>

                <!-- [name]="requestService.selectedRequest" -->
                <logzy-view-data-field [showPurpose]="true" name="Mr. Srinath Menon" label="Last Updated By"
                    [displayField]="'updated_by'" [displayField1]="'first_name'" [displayField2]="'last_name'"
                    fxFlex="11em" fxLayout="column" class="align-items-center"></logzy-view-data-field>

                <!-- [date]="requestService.selectedRequest?.updated_at" -->
                <logzy-view-data-field [showPurpose]="true" name="23 Mar 2023, 04:44 PM" label="Last Updated On"
                    fxFlex="11em" fxLayout="column" class="align-items-center"></logzy-view-data-field>

                <!-- [name]="requestService.selectedRequest"  -->
                <logzy-view-data-field [showPurpose]="true" name="srinath.menon@arconcontainer.com" label="Email"
                    [displayField]="'requestor'" [displayField1]="'email'" fxFlex="11em" fxLayout="column"
                    class="align-items-center"></logzy-view-data-field>

            </div>
        </div>
        <div fxLayout="column">
            <span class="desc"> Here follows the details of Commercials:</span>
            <div class="commercialTable">

                <div class="colHeader">
                    <div class="Head header" fxFlex="48"> <span>Particulars</span></div>
                    <div class="Head dataHead" fxFlex="48"><span>Commercials</span></div>
                </div>
                <div class="colData" *ngFor="let col of tableData">
                    <div class="Head" fxFlex="48">{{col.colhead}}</div>
                    <div class="data" fxFlex="48">{{col.coldata}}</div>
                </div>

            </div>
        </div>
        <div class="actionBtn">
            <button mat-raised-button class="addBtn" (click)="acceptQuote(true)">Accept Quote</button>
        </div>
    </ng-container>
    <ng-container *ngIf="quoteAccepted">
        <div class="content">
            <img src="assets/images/backgrounds/request-confirm.png" alt class="acceptedImg">
            <div class="accpetMsg">
                <span>Thank you for accepting the quote. Business team will get back to you with deal
                    confirmation.</span>
            </div>
            <div class="actionBtn accept">
                <button mat-raised-button class="Save" (click)="acceptQuote(false)">Take me Home</button>
            </div>
        </div>
    </ng-container>


</div>